import { render, staticRenderFns } from "./ToolbarCallCenter.vue?vue&type=template&id=4540015f&scoped=true"
import script from "./ToolbarCallCenter.vue?vue&type=script&lang=js"
export * from "./ToolbarCallCenter.vue?vue&type=script&lang=js"
import style0 from "./ToolbarCallCenter.vue?vue&type=style&index=0&id=4540015f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540015f",
  null
  
)

export default component.exports